var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8444 2.50006H9.16667C4.91111 2.50006 2.5 4.91117 2.5 9.16673V20.8334C2.5 25.089 4.91111 27.5001 9.16667 27.5001H20.8444C25.1 27.5001 27.5 25.089 27.5 20.8334V9.16673C27.5 4.91117 25.1 2.50006 20.8444 2.50006Z",
    fill: "#E5B910"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.21082 11.7112C8.64416 11.7112 8.17749 12.1779 8.17749 12.7557V21.3446C8.17749 21.9112 8.64416 22.3779 9.21082 22.3779C9.7886 22.3779 10.2553 21.9112 10.2553 21.3446V12.7557C10.2553 12.1779 9.7886 11.7112 9.21082 11.7112Z",
    fill: "white",
    fillOpacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0451 7.61115C14.4784 7.61115 14.0117 8.07781 14.0117 8.65559V21.3445C14.0117 21.9111 14.4784 22.3778 15.0451 22.3778C15.6228 22.3778 16.0895 21.9111 16.0895 21.3445V8.65559C16.0895 8.07781 15.6228 7.61115 15.0451 7.61115Z",
    fill: "white",
    fillOpacity: 0.7
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8003 16.2444C20.2225 16.2444 19.7559 16.7111 19.7559 17.2889V21.3444C19.7559 21.9111 20.2225 22.3778 20.7892 22.3778C21.367 22.3778 21.8336 21.9111 21.8336 21.3444V17.2889C21.8336 16.7111 21.367 16.2444 20.8003 16.2444Z",
    fill: "white",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.d3cc4b0667af12e66a2ef5ebaf708bc5.svg";
export { ForwardRef as ReactComponent };